import React, { useState, useEffect } from 'react';
import { db } from '../../config/firebase';
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc } from 'firebase/firestore';
import { BiSolidFilePdf } from 'react-icons/bi';
import './adminapp.css';

const AdminApp = () => {
    const [title, setTitle] = useState('');
    const [position, setPosition] = useState('');
    const [description, setDescription] = useState('');
    const [applications, setApplications] = useState([]);
    const [opportunities, setOpportunities] = useState([]);
    const [statusMap, setStatusMap] = useState({});

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await addDoc(collection(db, 'volunteerOpportunities'), {
                title,
                position,
                description,
                postedDate: new Date().toLocaleDateString(),
                isOpen: true
            });
            alert('Job post created successfully!');
            setTitle('');
            setPosition('');
            setDescription('');
            fetchOpportunities();
        } catch (error) {
            console.error('Error adding document: ', error);
            alert('There was an error creating the job post. Please try again.');
        }
    };

    const fetchApplications = async () => {
        const querySnapshot = await getDocs(collection(db, 'volunteerApplications'));
        const applicationsList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setApplications(applicationsList);
        
        const initialStatusMap = applicationsList.reduce((acc, application) => {
            acc[application.id] = application.status;
            return acc;
        }, {});
        setStatusMap(initialStatusMap);
    };

    const fetchOpportunities = async () => {
        const querySnapshot = await getDocs(collection(db, 'volunteerOpportunities'));
        const opportunitiesList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setOpportunities(opportunitiesList);
    };

    const stopApplication = async (id) => {
        try {
            await updateDoc(doc(db, 'volunteerOpportunities', id), { isOpen: false });
            fetchOpportunities();
        } catch (error) {
            console.error('Error updating document: ', error);
            alert('There was an error stopping the application. Please try again.');
        }
    };

    const updateApplicationStatus = async (id, status) => {
        try {
            await updateDoc(doc(db, 'volunteerApplications', id), { status });
            fetchApplications();
        } catch (error) {
            console.error('Error updating document: ', error);
            alert('There was an error updating the application status. Please try again.');
        }
    };

    const deleteApplication = async (id) => {
        try {
            await deleteDoc(doc(db, 'volunteerApplications', id));
            fetchApplications();
        } catch (error) {
            console.error('Error deleting document: ', error);
            alert('There was an error deleting the application. Please try again.');
        }
    };

    const deleteJobPost = async (id) => {
        try {
            await deleteDoc(doc(db, 'volunteerOpportunities', id));
            fetchOpportunities();
        } catch (error) {
            console.error('Error deleting document: ', error);
            alert('There was an error deleting the job post. Please try again.');
        }
    };

    useEffect(() => {
        fetchApplications();
        fetchOpportunities();
    }, []);

    const handleStatusChange = (id, newStatus) => {
        setStatusMap((prevStatusMap) => ({
            ...prevStatusMap,
            [id]: newStatus,
        }));
    };

    return (
        <div className='adminapp_container'>
            <div className='adminapp_intro'>
                <h1>Application Page Management</h1>
            </div>
            <div className="create_app">
                <div className="create_app_text">
                    <h2>Create Opportunities</h2>
                    <p>List your volunteering openings and find the perfect candidates.</p>
                </div>
                <div className="create_form">
                    <form onSubmit={handleSubmit}>
                        <label htmlFor="title" className='form_label'>Title</label>
                        <input type="text" required placeholder='e.g., Music Teacher' className='form_input' value={title} onChange={(e) => setTitle(e.target.value)} />

                        <label htmlFor="description" className='form_label'>Description</label>
                        <textarea type="text" required placeholder='Enter role description' value={description} onChange={(e) => setDescription(e.target.value)} />

                        <button className='form_btn' type="submit">Submit</button>
                    </form>
                </div>
            </div>
            <div className="access_app">
                <div className="app_process">
                    <h2>EWCDC Received Job Applications</h2>
                </div>
                <div className="app_container">
                    {applications.length === 0 ? (
                        <p>No applications received yet.</p>
                    ) : (
                        applications.map((application) => (
                            <div className="application_card" key={application.id}>
                                <h2>Job Position: {application.position}</h2>
                                <p>Name: {application.volunteerName}</p>
                                <p>Cell No: {application.cellNo}</p>
                                <p>Code: {application.code}</p>
                                <p>Status: {application.status}</p>
                                <a href={application.cvUrl} target="_blank" rel="noopener noreferrer"><BiSolidFilePdf className='pdf_file' /> Download CV</a>
                                <button className="delete_btn" onClick={() => deleteApplication(application.id)}>Delete</button>
                                <div className="status_update">
                                    <select onChange={(e) => handleStatusChange(application.id, e.target.value)} value={statusMap[application.id] || ''}>
                                        <option value="Application Received">Application Received</option>
                                        <option value="Under Review">Under Review</option>
                                        <option value="Accepted">Accepted</option>
                                        <option value="Rejected">Rejected</option>
                                    </select>
                                    <button className="update_btn" onClick={() => updateApplicationStatus(application.id, statusMap[application.id])}>Update Status</button>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
            <div className="live_app_container">
                <div className="live_app_heading">
                    <h1>Ongoing Applications</h1>
                </div>
                <div className="live_app_holder">
                    {opportunities.map((opportunity) => (
                        <div className='live_card' key={opportunity.id}>
                            <h1>Job Title: {opportunity.title}</h1>
                            <h1>Date Posted: {opportunity.postedDate ? new Date(opportunity.postedDate.seconds * 1000).toLocaleDateString() : 'N/A'}</h1>
                            <h3>Status: {opportunity.isOpen ? 'Running' : 'Stopped'}</h3>
                            <p>{opportunity.description}</p>
                            <button
                                className='stop_app'
                                onClick={() => stopApplication(opportunity.id)}
                            >
                                Stop Application
                            </button>
                            <button
                                className='delete_app'
                                onClick={() => deleteJobPost(opportunity.id)}
                            >
                                Delete Application
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default AdminApp;
